import { createAction } from '../../../../store.model';
import { ActionType } from '../task-list-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reset {}

export const reset = createAction<ActionType, Reset>(ActionType.TC__TL__RESET);
